import React from 'react'
import { Component } from 'preact'
import styles from './FullScreen.scss'

import ScrollLock from 'react-scrolllock';




class FullScreenMenu extends Component {

    constructor(props) {
        super(props)
    }

    componentDidMount() {
        const scrollRef = document.getElementById('scrollable')
        this.setState({
            scrollRef
        })
    }

    render() {
        let { title, extraFunctionTop = null, extraFunctionBottom = null, open, close, children } = this.props
        let { scrollRef } = this.state
        return (
            (open) ?
                <div className={styles.menu}>
                    <div className={styles.header}>
                        <h2 style={{ marginTop: '7px' }}>{title}</h2>
                        <button className={styles.close} onClick={close} aria-label = "Close"/>
                        {(extraFunctionTop !== null) ?
                            <div className={styles.extraFunctionTop}>
                                {extraFunctionTop}
                            </div>
                            :
                            <div />}
                    </div>
                    {(scrollRef) ?
                        <ScrollLock touchScrollTarget={scrollRef} />
                        :
                        null
                    }
                    <div className={styles.body} id='scrollable'>
                        {children}
                    </div>
                    {(extraFunctionBottom !== null) ?
                        <div className={styles.extraFunctionBottom}>
                            {extraFunctionBottom}
                        </div> :
                        <div />}
                </div>
                :
                <div />
        )
    }
}

export default FullScreenMenu